interface RegionWithCountryCodes {
  id: string;
  name: string;
  countryCodes?: string[];
}

interface CountryOption {
  code: string;
  name: string;
}

interface FilteredLocationOptions {
  filteredCountryNames: string[];
  filteredCountryCodes: string[];
  filteredRegionNames: string[];
  filteredRegionIds: string[];
  disabledCountryNames: string[];
  disabledCountryCodes: string[];
}

export const filterCaseLocationOptions = (
  allCountries: CountryOption[],
  allRegions: RegionWithCountryCodes[],
  selectedCountryCodes: string[],
  selectedRegionIds: string[],
): FilteredLocationOptions => {
  const hasAllCountriesSelected =
    selectedCountryCodes.length >= allCountries.length;

  const hasRegionSelection = selectedRegionIds.length > 0;
  const hasAllRegionsSelected = selectedRegionIds.length >= allRegions.length;
  const hasPartialRegionSelection =
    hasRegionSelection && !hasAllRegionsSelected;

  let filteredCountries = allCountries;
  if (hasPartialRegionSelection && !hasAllCountriesSelected) {
    const selectedRegionSet = new Set(selectedRegionIds);
    const countryCodesInSelectedRegions = new Set(
      allRegions
        .filter((r) => selectedRegionSet.has(r.id))
        .flatMap((r) => r.countryCodes ?? []),
    );
    filteredCountries = allCountries.filter((c) =>
      countryCodesInSelectedRegions.has(c.code),
    );
  }

  const enabledCountryCodeSet = new Set(filteredCountries.map((c) => c.code));

  return {
    filteredCountryNames: allCountries.map((c) => c.name),
    filteredCountryCodes: allCountries.map((c) => c.code),
    filteredRegionNames: allRegions.map((r) => r.name),
    filteredRegionIds: allRegions.map((r) => r.id),
    disabledCountryNames: allCountries
      .filter((c) => !enabledCountryCodeSet.has(c.code))
      .map((c) => c.name),
    disabledCountryCodes: allCountries
      .filter((c) => !enabledCountryCodeSet.has(c.code))
      .map((c) => c.code),
  };
};
